export default __webpack_public_path__ + "static/media/modelo.61a7a641.png";